/* ASTREK home experience — vanilla JS + GSAP port of components/Experience.tsx */
(function () {
  'use strict';

  function init() {
    var root = document.getElementById('astrek-experience');
    if (!root || root.dataset.axInit || typeof gsap === 'undefined') return;
    root.dataset.axInit = '1';
    if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

    var config = {};
    var cfgEl = root.querySelector('[data-astrek-home-config]');
    if (cfgEl) {
      try {
        config = JSON.parse(cfgEl.textContent);
      } catch (e) {
        config = {};
      }
    }

    /* ---------- pre-processing: split hero title into chars ---------- */
    root.querySelectorAll('[data-hero-title]').forEach(function (el) {
      var text = el.textContent.trim();
      el.textContent = '';
      for (var i = 0; i < text.length; i++) {
        var s = document.createElement('span');
        s.setAttribute('data-char', '');
        s.textContent = text[i] === ' ' ? '\u00A0' : text[i];
        el.appendChild(s);
      }
    });

    /* ---------- pre-processing: blank-line-separated text -> <p> ---------- */
    root.querySelectorAll('[data-paragraphs]').forEach(function (el) {
      var raw = el.textContent.replace(/\r\n/g, '\n').trim();
      var revealAttr = el.closest('[data-panel]') ? 'data-reveal' : 'data-m-reveal';
      el.textContent = '';
      raw.split(/\n\s*\n/).forEach(function (part) {
        if (!part.trim()) return;
        var p = document.createElement('p');
        p.setAttribute(revealAttr, '');
        p.textContent = part.trim();
        el.appendChild(p);
      });
    });

    /* ---------- pre-processing: mobile helmet story layout ----------
       Mirrors the desktop paragraphs, re-flowed as in the design: intro
       line, merged intro body, mountain photo, first half of the story,
       helmet close-up, second half, closing lines, brand image. */
    (function buildMobileHelmet() {
      var host = root.querySelector('[data-m-helmet-body]');
      if (!host || !config.helmetBody) return;
      var paragraphs = config.helmetBody.replace(/\r\n/g, '\n').trim().split(/\n\s*\n/);
      var assets = config.assets || {};

      function p(text, first, flush) {
        if (!text) return;
        var el = document.createElement('p');
        el.className = 'ax-m-helmet-p' + (first ? ' ax-m-helmet-p--first' : '') + (flush ? ' ax-m-helmet-p--flush' : '');
        el.setAttribute('data-m-reveal', '');
        el.textContent = text;
        host.appendChild(el);
      }
      function img(src, alt, close) {
        var el = document.createElement('img');
        el.className = 'ax-m-helmet-img' + (close ? ' ax-m-helmet-img--close' : '');
        el.setAttribute('data-m-reveal', '');
        el.src = src;
        el.alt = alt;
        host.appendChild(el);
      }

      var introParts = (paragraphs[0] || '').split('\n');
      p(introParts[0], true);
      p(introParts.slice(1).join(' '));
      if (assets.mountain) img(assets.mountain, 'Snow-covered mountain peak in mist');

      var story = paragraphs[1] || '';
      var pivot = story.indexOf('It is your on-slope JARVIS');
      var storyA = pivot >= 0 ? story.slice(0, pivot).replace(/\s+$/, '') : story;
      var storyB = pivot >= 0 ? story.slice(pivot) : '';
      p(storyA, false, true);
      if (assets.helmet) img(assets.helmet, 'Glowing wireframe close-up of the ASTREK helmet', true);
      p(storyB, false, true);

      (paragraphs[2] || '').split('\n').forEach(function (line) {
        p(line);
      });

      if (assets.helmet) {
        var brand = document.createElement('div');
        brand.className = 'ax-m-helmet-brand';
        brand.setAttribute('data-m-reveal', '');
        var bg = document.createElement('img');
        bg.src = assets.helmet;
        bg.alt = '';
        brand.appendChild(bg);
        var logo = root.querySelector('.ax-logo');
        if (logo) brand.appendChild(logo.cloneNode(true));
        host.appendChild(brand);
      }
    })();

    /* ---------- refs ---------- */
    var heroImg = root.querySelector('[data-hero-img]');
    var rail = root.querySelector('[data-rail]');
    var desktop = root.querySelector('[data-stage]');
    var stageClose = root.querySelector('[data-stage-close]');
    var mPanelWrap = root.querySelector('[data-m-panel-wrap]');
    var mPanels = Array.prototype.slice.call(root.querySelectorAll('[data-m-panel]'));
    var reserveNotes = Array.prototype.slice.call(root.querySelectorAll('[data-reserve-note]'));
    var overlays = {
      menu: Array.prototype.slice.call(root.querySelectorAll('[data-overlay="menu"]')),
      social: Array.prototype.slice.call(root.querySelectorAll('[data-overlay="social"]')),
    };
    var panels = {
      building: root.querySelector('[data-panel="building"]'),
      helmet: root.querySelector('[data-panel="helmet"]'),
      join: root.querySelector('[data-panel="join"]'),
    };

    /* ---------- state ---------- */
    var panel = null;
    var menuOpen = false;
    var socialOpen = false;
    var marquee = null;
    var hoverTimer = null;
    var reserveTimer = null;

    var canHover = function () {
      return window.matchMedia('(hover: hover)').matches;
    };

    /* ---------- intro ---------- */
    /* x: 0 clears the px offset GSAP parses from the CSS translateX(105%)
       fallback — otherwise every xPercent tween stacks on top of it */
    gsap.set([panels.building, panels.helmet, panels.join], { xPercent: 105, x: 0 });
    var intro = gsap.timeline({ defaults: { ease: 'power3.out' } });
    intro
      .from(heroImg, { scale: 1.14, duration: 2.4, ease: 'power2.out' }, 0)
      .from(root.querySelectorAll('[data-char]'), { yPercent: 120, opacity: 0, stagger: 0.028, duration: 0.9 }, 0.35)
      .from(root.querySelectorAll('[data-hero-sub]'), { y: 18, opacity: 0, duration: 0.7 }, 1.0)
      .from(root.querySelectorAll('[data-header]'), { y: -16, opacity: 0, duration: 0.6 }, 0.15)
      .from(root.querySelectorAll('[data-card]'), { y: 30, opacity: 0, stagger: 0.07, duration: 0.7 }, 0.6);
    gsap.to(heroImg, {
      scale: 1.06,
      duration: 20,
      yoyo: true,
      repeat: -1,
      ease: 'sine.inOut',
      delay: 2.5,
    });

    /* seamless marquee on the desktop card rail — hover pauses it, and
       dragging maps pixel deltas onto tween progress (wrapped 0–1) so the
       loop stays seamless. A 5px threshold separates drags from card
       clicks; the click that follows a drag is swallowed in capture. */
    if (rail) {
      marquee = gsap.to(rail, { xPercent: -50, duration: 36, ease: 'none', repeat: -1 });
      var wrap01 = gsap.utils.wrap(0, 1);
      var railDrag = null;
      var railDragged = false;

      rail.addEventListener('mouseenter', function () {
        marquee.pause();
      });
      rail.addEventListener('mouseleave', function () {
        if (!railDrag) marquee.resume();
      });

      rail.addEventListener('pointerdown', function (e) {
        if (!e.isPrimary) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        railDrag = { x: e.clientX };
        railDragged = false;
        e.preventDefault();
      });
      rail.addEventListener('pointermove', function (e) {
        if (!railDrag || !e.isPrimary) return;
        var dx = e.clientX - railDrag.x;
        if (!railDragged) {
          if (Math.abs(dx) <= 5) return;
          railDragged = true;
          rail.setPointerCapture(e.pointerId);
          rail.style.cursor = 'grabbing';
          marquee.pause();
          railDrag.x = e.clientX;
          return;
        }
        railDrag.x = e.clientX;
        marquee.progress(wrap01(marquee.progress() - dx / (rail.offsetWidth / 2)));
      });
      var railDragEnd = function (e) {
        if (!railDrag) return;
        railDrag = null;
        rail.style.cursor = '';
        /* released outside the rail: hover-resume won't fire, do it here */
        var r = rail.getBoundingClientRect();
        var inside =
          e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) marquee.resume();
      };
      rail.addEventListener('pointerup', railDragEnd);
      rail.addEventListener('pointercancel', railDragEnd);
      rail.addEventListener(
        'click',
        function (e) {
          if (railDragged) {
            e.preventDefault();
            e.stopPropagation();
            railDragged = false;
          }
        },
        true
      );
    }

    /* mobile card reveals on scroll — fire the moment a card peeks in */
    if (typeof ScrollTrigger !== 'undefined') {
      root.querySelectorAll('[data-m-card]').forEach(function (card) {
        gsap.from(card, {
          y: 30,
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: { trigger: card, start: 'top bottom' },
        });
      });
    }

    /* ---------- panels ---------- */
    function setPanelState(next) {
      var prev = panel;
      if (next === prev) return;
      panel = next;

      if (prev) {
        var prevEl = panels[prev];
        if (prevEl) {
          gsap.to(prevEl, { xPercent: 105, duration: 0.6, ease: 'power3.in' });
          prevEl.setAttribute('aria-hidden', 'true');
        }
      }

      if (next) {
        var el = panels[next];
        if (el) {
          el.setAttribute('aria-hidden', 'false');
          gsap
            .timeline()
            .fromTo(el, { xPercent: 105 }, { xPercent: 0, duration: 0.85, ease: 'power3.inOut' })
            .fromTo(
              el.querySelectorAll('[data-reveal]'),
              { y: 26, opacity: 0 },
              { y: 0, opacity: 1, duration: 0.55, stagger: 0.06, ease: 'power2.out' },
              '-=0.3'
            );
          if (next === 'helmet') {
            gsap.to(el.querySelector('[data-helmet-img]'), {
              y: -12,
              duration: 3.4,
              yoyo: true,
              repeat: -1,
              ease: 'sine.inOut',
            });
          }
        }

        /* mobile full-screen panel fade */
        if (mPanelWrap) {
          mPanelWrap.hidden = false;
          mPanels.forEach(function (pg) {
            pg.hidden = pg.getAttribute('data-m-panel') !== next;
          });
          gsap.fromTo(mPanelWrap, { opacity: 0 }, { opacity: 1, duration: 0.3 });
          gsap.fromTo(
            mPanelWrap.querySelectorAll('[data-m-panel="' + next + '"] [data-m-reveal]'),
            { y: 24, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.08, duration: 0.5, ease: 'power2.out', delay: 0.1 }
          );
        }
      } else if (mPanelWrap) {
        mPanelWrap.hidden = true;
      }

      if (stageClose) stageClose.hidden = !next;
    }

    function openPanel(id) {
      setPanelState(panel === id ? null : id);
    }
    function closePanel() {
      setPanelState(null);
    }

    /* ---------- menu / social overlays ---------- */
    function openOverlay(kind) {
      if (kind === 'menu') menuOpen = true;
      else socialOpen = true;
      overlays[kind].forEach(function (el) {
        el.hidden = false;
        gsap
          .timeline()
          .fromTo(el, { opacity: 0 }, { opacity: 1, duration: 0.4 })
          .fromTo(
            el.querySelectorAll('[data-menu-item]'),
            /* both overlays fade in place (no slide) so items only move
               on hover */
            { opacity: 0 },
            { opacity: 1, stagger: 0.07, duration: 0.55, ease: 'power3.out' },
            '-=0.15'
          );
      });
    }

    function closeOverlay(kind) {
      if (kind === 'menu') menuOpen = false;
      else socialOpen = false;
      var els = overlays[kind].filter(function (el) {
        return !el.hidden;
      });
      if (!els.length) return;
      gsap.to(els, {
        opacity: 0,
        duration: 0.3,
        onComplete: function () {
          els.forEach(function (el) {
            el.hidden = true;
          });
        },
      });
    }

    /* hover open/close for the header overlays (desktop only) */
    function cancelHoverClose() {
      if (hoverTimer) {
        window.clearTimeout(hoverTimer);
        hoverTimer = null;
      }
    }
    function scheduleHoverClose() {
      cancelHoverClose();
      hoverTimer = window.setTimeout(function () {
        hoverTimer = null;
        closeOverlay('menu');
        closeOverlay('social');
      }, 220);
    }
    function hoverLeave() {
      if (!canHover()) return;
      scheduleHoverClose();
    }

    /* ---------- actions ---------- */
    function handleReserve() {
      var url = root.getAttribute('data-reserve-url');
      if (url) {
        window.location.href = url;
        return;
      }
      reserveNotes.forEach(function (n) {
        n.hidden = false;
      });
      if (reserveTimer) window.clearTimeout(reserveTimer);
      reserveTimer = window.setTimeout(function () {
        reserveNotes.forEach(function (n) {
          n.hidden = true;
        });
      }, 2600);
    }

    function act(action) {
      if (action === 'building' || action === 'helmet' || action === 'join') openPanel(action);
      else if (action === 'reserve') handleReserve();
      else if (action === 'lab') window.location.href = root.getAttribute('data-lab-url') || '/pages/lab';
    }

    /* ---------- wiring ---------- */
    var menuToggle = root.querySelector('[data-menu-toggle]');
    var socialToggle = root.querySelector('[data-social-toggle]');

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        if (canHover()) return;
        if (socialOpen) closeOverlay('social');
        if (menuOpen) closeOverlay('menu');
        else openOverlay('menu');
      });
      menuToggle.addEventListener('mouseenter', function () {
        if (!canHover()) return;
        cancelHoverClose();
        if (socialOpen) closeOverlay('social');
        if (!menuOpen) openOverlay('menu');
      });
      menuToggle.addEventListener('mouseleave', hoverLeave);
    }

    if (socialToggle) {
      socialToggle.addEventListener('click', function () {
        if (canHover()) return;
        if (menuOpen) closeOverlay('menu');
        if (socialOpen) closeOverlay('social');
        else openOverlay('social');
      });
      socialToggle.addEventListener('mouseenter', function () {
        if (!canHover()) return;
        cancelHoverClose();
        if (menuOpen) closeOverlay('menu');
        if (!socialOpen) openOverlay('social');
      });
      socialToggle.addEventListener('mouseleave', hoverLeave);
    }

    /* overlay backdrops close on click; nav clicks stay inside */
    Object.keys(overlays).forEach(function (kind) {
      overlays[kind].forEach(function (el) {
        el.addEventListener('click', function () {
          closeOverlay(kind);
        });
        var nav = el.querySelector('nav');
        if (nav) {
          nav.addEventListener('click', function (e) {
            e.stopPropagation();
          });
          nav.addEventListener('mouseenter', function () {
            if (canHover()) cancelHoverClose();
          });
          nav.addEventListener('mouseleave', hoverLeave);
        }
      });
    });

    /* menu items */
    root.querySelectorAll('[data-menu-item][data-action]').forEach(function (item) {
      item.addEventListener('click', function () {
        closeOverlay('menu');
        act(item.getAttribute('data-action'));
      });
    });

    /* rail + mobile cards */
    root.querySelectorAll('[data-card], [data-m-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        if (menuOpen) closeOverlay('menu');
        if (socialOpen) closeOverlay('social');
        act(card.getAttribute('data-action'));
      });
    });

    /* close buttons + stage blank area */
    root.querySelectorAll('[data-panel-close]').forEach(function (btn) {
      btn.addEventListener('click', closePanel);
    });
    if (stageClose) stageClose.addEventListener('click', closePanel);

    /* keyboard */
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (menuOpen) closeOverlay('menu');
      else if (socialOpen) closeOverlay('social');
      else closePanel();
    });

    /* keep card videos playing: mobile browsers defer loading/autoplay
       for videos that start below the fold; nudge each one to load and
       play once it nears the viewport */
    var cardVideos = Array.prototype.slice.call(
      root.querySelectorAll('.ax-card video, .ax-m-card video')
    );
    cardVideos.forEach(function (v) {
      var card = v.closest('.ax-card, .ax-m-card');
      if (!card) return;
      v.addEventListener('playing', function () {
        card.classList.add('is-video-playing');
      });
      v.addEventListener('error', function () {
        card.classList.remove('is-video-playing');
      });
      if (!v.paused && v.readyState >= 2) card.classList.add('is-video-playing');
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var v = entry.target;
            if (v.readyState === 0) {
              v.preload = 'auto';
              v.load();
            }
            if (v.paused)
              v.play().catch(function () {
                /* autoplay blocked (e.g. low-power mode) */
              });
          });
        },
        { rootMargin: '150px' }
      );
      cardVideos.forEach(function (v) {
        io.observe(v);
      });
    }

    /* hero mouse parallax */
    if (desktop && heroImg) {
      desktop.addEventListener('mousemove', function (e) {
        gsap.to(heroImg, {
          x: (e.clientX / window.innerWidth - 0.5) * -14,
          y: (e.clientY / window.innerHeight - 0.5) * -10,
          duration: 1.2,
          ease: 'power2.out',
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
